import type { TechSupportMetrics } from "@expert/sales-tools";

export function getMockPerformanceMetrics(): TechSupportMetrics {
    return {
        entireRepPerformance: 86, // 86 / 90 → Close to target (ERP, 0–100 scale)
        fiveStarRating: 4.6, // 4.6 / 4.8 → Close to target (NPS, 0–5 scale)
        callResolutionTime: 2000, // 1350 / 2000 → Behind
        netEnrolls: 1, // 1 / 1 → Within target
    };
}
